/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Endpoint_Row_ShareInputs */

const en_endpoint_row_share = /** @type {(inputs: Endpoint_Row_ShareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} of calls`)
};

const zh_hans1_endpoint_row_share = /** @type {(inputs: Endpoint_Row_ShareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`占调用的 ${i?.value}`)
};

const pt_br2_endpoint_row_share = /** @type {(inputs: Endpoint_Row_ShareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} das chamadas`)
};

const es_endpoint_row_share = /** @type {(inputs: Endpoint_Row_ShareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} de las llamadas`)
};

const fr_endpoint_row_share = /** @type {(inputs: Endpoint_Row_ShareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} des appels`)
};

const de_endpoint_row_share = /** @type {(inputs: Endpoint_Row_ShareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} der Aufrufe`)
};

const ru_endpoint_row_share = /** @type {(inputs: Endpoint_Row_ShareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} вызовов`)
};

const it_endpoint_row_share = /** @type {(inputs: Endpoint_Row_ShareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} delle chiamate`)
};

/**
* | output |
* | --- |
* | "{value} of calls" |
*
* @param {Endpoint_Row_ShareInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_row_share = /** @type {((inputs: Endpoint_Row_ShareInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Row_ShareInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_row_share(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_row_share(inputs)
	if (locale === "es") return es_endpoint_row_share(inputs)
	if (locale === "fr") return fr_endpoint_row_share(inputs)
	if (locale === "de") return de_endpoint_row_share(inputs)
	if (locale === "ru") return ru_endpoint_row_share(inputs)
	if (locale === "it") return it_endpoint_row_share(inputs)
	return en_endpoint_row_share(inputs)
});